module.exports = __webpack_public_path__ + "img/heart_and_soul_thumb.7bc6cf61.jpg";